module.exports = __webpack_public_path__ + "static/media/6.5901f26d.jpg";